export default {
  collections: 'Collections',
  systems: 'Systems',
  filters: 'Filter by',
  'alt-complementary-text': 'Image related to the product',
}
